<template>
    <div class="modal">
        <div class="photo" :style="{ 'background-image': 'url(' + photoUrl + ')' }">
            <div class="btn" @click="close">
                <img src="@/assets/img/+.svg">
            </div>
        </div>
        <div class="detail">
            <div class="card">
                <div class="title">
                    {{ shop.alias }}
                </div>
                <div class="address">
                    {{ fullAddress }}
                </div>
                <div class="phone">
                    <img src="@/assets/img/phone.svg">
                    <a :href="'tel:' + this.shop.phone">{{ shop.phone }}</a>
                </div>
            </div>
            <div class="content">
                <div class="description">{{ shop.description }}</div>
                <div class="divider"/>
                <div class="note"><span>注意事項</span><br/>{{ shop.caution }}</div>
                <div class="work">
                    <div class="info-title">
                        營業時間 <img src="@/assets/img/google.svg">
                    </div>
                    <div class="work-content weight">{{ todayWork }}</div>
                    <div class="work-content">{{ notTodayWork }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ShopDetail',
        props: {
            shop: {
                required: true,
                type: Object
            },
            photoUrl: {
                required: true,
                type: String
            }
        },
        computed: {
            fullAddress() {
                return (this.shop.city + this.shop.district + this.shop.road + this.shop.additional) || '';
            },
            todayWork() {
                return this.shop.work.split("\n")[0];
            },
            notTodayWork() {
                let work = this.shop.work.split("\n");
                work.shift();

                return work.join("\n");
            },
        },
        methods: {
            close() {
                this.$emit('onClose');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal {
        position: fixed;
        top: 0;
        left: 0;
        width: inherit;
        min-height: 100%;
        max-height: 100%;
        overflow-y: scroll;
        z-index: 99;
        background-color: white;

        &::-webkit-scrollbar {
            display: none;
        }

        .photo {
            background-position: 50% 50%;
            background-size: cover;
            background-repeat: no-repeat;
            height: 250px;
            position: absolute;
            width: 100%;
            display: flex;
            justify-content: flex-end;

            .btn {
                padding: 15px;
            }
        }
    }

    .detail {
        .card {
            margin: 185px 15px 15px 15px;
            opacity: 0.95;
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.35);
            text-align: left;
            padding: 15px;
            box-sizing: border-box;
            width: calc(100% - 30px);
            font-family: "PingFang TC";
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;

            .title {
                color: #000000;
                font-size: 26px;
                line-height: 37px;
                margin: 5px 0;
            }

            .address {
                color: #4A4A4A;
                margin: 5px 0;
            }

            .phone {
                display: flex;
                align-items: center;
                margin: 5px 0;

                a {
                    margin-left: 5px;
                    color: #339933;
                    text-decoration: none;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                    font-family: "PingFang TC"
                }
            }
        }

        .content {
            margin: 15px 30px;
            text-align: left;

            .description {
                margin: 15px 0;
                color: #4A4A4A;
                font-size: 14px;
                line-height: 23.8px;
                font-family: "PingFang TC";
                font-weight: 500;
                letter-spacing: 0;
                white-space: pre-wrap;
            }

            .note {
                color: #4A4A4A;
                font-size: 14px;
                line-height: 23.8px;
                font-family: "PingFang TC";
                letter-spacing: 0;
                white-space: pre-wrap;

                span {
                    color: #9B9B9B;
                    font-size: 13px;
                    line-height: 18px;
                    margin-bottom: 5px;
                }
            }

            .work {
                margin-top: 15px;

                .info-title {
                    color: #9B9B9B;
                    font-family: "PingFang TC";
                    font-size: 13px;
                    line-height: 18px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 5px;

                    img {
                        margin-left: 10px;
                        width: auto;
                        height: 16px;
                    }
                }

                .work-content {
                    white-space: pre-wrap;
                    color: #4A4A4A;
                    font-size: 14px;
                    line-height: 23.8px;
                    font-family: "PingFang TC";
                    letter-spacing: 0;

                    &.weight {
                        font-weight: 800;
                    }
                }
            }
        }

        .divider {
            background-color: #F5F5F5;
            height: 1px;
            margin: 15px 0;
        }
    }
</style>
